import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations, Roles } from "../../shared/permissions/permissionsConfig"
import { getAllAdmNumbers, getAssignedAdmNumbers } from "../../user/utils/userHelper"
import { getRevenueStatsForAdms } from "../utils/revenueStatsForAdms"

export const queryAdmYearRevenueOverview = {
  async admYearRevenueOverview(_parent, args, context, _info) {
    const {
      year = new Date().getFullYear(),
      page,
      limit = 10,
      sort = {
        orderBy: "admNumber",
        direction: "asc",
      },
    } = args

    const user = context?.user
    let assignedAdms = []

    await checkPermissions({
      user,
      domainObject: DomainObjects.REVENUES,
      operation: Operations.READ,
    })

    if (user.role === Roles.ADMIN) {
      assignedAdms = await getAllAdmNumbers()
    }

    if ([Roles.REGIONAL_LEAD, Roles.ADM_GVL].includes(user.role)) {
      assignedAdms = await getAssignedAdmNumbers({
        employeeNumber: user.employeeNumber,
      })
    }

    return await getRevenueStatsForAdms({
      admNumbers: assignedAdms?.assignedAdmNumbers,
      year,
      limit,
      page,
      sort,
    })
  },
}
